import { useEffect, useState } from "react";

function computeCount() {
  if (typeof window === "undefined") return 3;
  if (window.innerWidth < 640) return 1;
  if (window.innerWidth < 1024) return 2;
  return 3;
}

export function useResponsiveCount() {
  const [count, setCount] = useState(computeCount);

  useEffect(() => {
    const onResize = () => setCount(computeCount());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return count;
}
